import { motion } from 'framer-motion';
import { css, styled } from 'styled-components';

import {
    designColor,
    floorGameDuration as duration,
    floorGameEasing as easing,
    styledInteraction,
    styledTypography,
} from '@pkg/primitives';

import {
    textAreaAttachmentTransition,
    TextAreaAttachmentVariant,
    textAreaAttachmentVariants,
} from '../../ProfileHeader.motion';

import { tokens } from './CharacterCount.tokens';

interface StyledCharacterCountProps {
    $error?: boolean;
}

export const StyledCharacterCount = styled(motion.div).attrs({
    variants: textAreaAttachmentVariants,
    initial: TextAreaAttachmentVariant.Hidden,
    animate: TextAreaAttachmentVariant.Show,
    exit: TextAreaAttachmentVariant.Hidden,
    transition: textAreaAttachmentTransition,
})<StyledCharacterCountProps>`
    ${styledInteraction.interactionDisable};

    position: absolute;
    left: 100%;
    top: 50%;
    margin-top: ${(tokens.fontSize / 2) * -1}px;
    margin-left: ${tokens.offsetX}px;
    color: rgba(255, 255, 255, 0.6);
    opacity: 0;
    transition: color ${duration.normal}ms ${easing.cubic};

    ${({ $error }) =>
        $error &&
        css`
            color: ${designColor.red};
        `}
`;

export const Label = styled.p`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    font-size: ${tokens.fontSize}px;
    font-weight: 700;
    letter-spacing: -0.02em;
    color: currentColor;
`;
